const saveLog = (value) => {
  const dataLog = {
    text: `${(
      new Date().toLocaleDateString() +
        value?.error +
        value?.pageError +
        value.userID ?? "Sinusuario"
    ).trim()}`,
  };
  return fetch(`/api/catchBugs`, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(dataLog),
  })
    .then((res) => res.json())
    .then((res) => res.data);
};

export { saveLog };
